import React from 'react';
import { CheckIcon } from 'lucide-react';
import { included } from '../data/copy';
export function SolutionSection() {
  return <section className="w-full bg-indigo-deep py-11 sm:py-14" aria-labelledby="solution-heading" data-id="element-186" data-mp="3aauc9h131dfy">
      <div className="mx-auto max-w-5xl px-6" data-id="element-187" data-mp="3oa3grjfxej43">
        <div className="mx-auto max-w-2xl text-center" data-id="element-188" data-mp="3ja7eppqsh1r6">
          <p className="flex items-center justify-center gap-4 font-sans text-[11px] font-semibold uppercase tracking-[0.24em] text-gold-soft" data-id="element-189" data-mp="3j8mizwsqncrq">
            <span className="h-px w-10 bg-gold/60" aria-hidden="true" data-id="element-190" data-mp="3t8dh08gic9wk" />
            Introducing
            <span className="h-px w-10 bg-gold/60" aria-hidden="true" data-id="element-191" data-mp="aue6rzaiwylq" />
          </p>

          <h2 id="solution-heading" className="mt-6 font-display text-[2rem] leading-[1.1] text-ivory sm:text-[2.75rem]" data-id="element-192" data-mp="aw8jiqbn5keq">
            Plan an entire year of art classes today
          </h2>
          <p className="mx-auto mt-3 max-w-xl font-display text-xl leading-snug text-gold-soft" data-id="element-193" data-mp="kqh9p7d7919q">
            The complete professional 6-volume system.
          </p>
        </div>

        <div className="mx-auto mt-9 max-w-3xl space-y-4 text-center font-sans text-[0.95rem] leading-relaxed text-ivory/75" data-id="element-194" data-mp="36c6wp6j3u6z6">
          <p data-id="element-195" data-mp="3bbjsigryeodw">
            This is not a random collection of art activities copied from the
            internet. It is not a theoretical book you have to rewrite before it
            works in a real class.
          </p>
          <p className="font-medium text-ivory" data-id="element-196" data-mp="3p9q5c91nhnl2">
            This is a complete professional visual system — so you walk into each
            class prepared, confident, and ready to teach an art experience your
            students can see, understand, and create from.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-x-8 gap-y-3 border-t border-ivory/15 pt-9 sm:grid-cols-2" data-id="element-197" data-mp="6v8vqudpjhy3">
          {included.map(item => <li key={item} className="flex items-start gap-3 font-sans text-[0.9rem] leading-relaxed text-ivory/85" data-id="element-198" data-mp="bvwkf9egrmp5">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={2.4} aria-hidden="true" data-id="element-199" data-mp="gty5fzvg9w39" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}